<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} HqName` }}
            </h4>
            <v-form ref="hqNameForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="hqNameModel.name"
                    label="HqName Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'HqName Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { HqName } from "@/models/HqName";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      hqNameModel: new HqName(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "HqNames",
          disabled: false,
          href: "/admin/hqNames",
        },
        {
          text: "HqName Detail",
          disabled: false,
          href: `/admin/hqName/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} HqName`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    hqName: {
      query: gql`
        query HqName($id: ID!) {
          hqName(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.hqNameModel.id = this.hqName.id;
        this.hqNameModel.name = this.hqName.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.hqNameForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateHqName()
          .then(() => {
            this.$swal("Success!", "HqName was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the hqName, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createHqName()
          .then(() => {
            this.$swal("Success!", "HqName was created", "success");
            window.location.href = `/admin/hqName/${self.hqNameModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the hqName, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateHqName() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($hqName: HqNameUpdateInput!) {
              updateHqName(hqName: $hqName) {
                id
                updated
              }
            }
          `,
          variables: {
            hqName: {
              id: self.hqNameModel.id,
              name: self.hqNameModel.name,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the hqName!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createHqName() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createHqName($hqName: HqNameCreateInput!) {
              createHqName(hqName: $hqName) {
                id
              }
            }
          `,
          variables: {
            hqName: {
              name: self.hqNameModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the HqName Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createHqName) {
          self.hqNameModel.id = response?.data?.createHqName?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
